import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import { commonItemPropsArray } from '../styles/types.js';

var extractProps = function extractProps(props) {
  for (var _len = arguments.length, selectedProps = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    selectedProps[_key - 1] = arguments[_key];
  }
  return selectedProps.reduce(function (acc, key) {
    if (props[key] !== undefined) {
      acc[key] = props[key];
    }
    return acc;
  }, {});
};
var extractCommonItemProps = function extractCommonItemProps(props) {
  return extractProps.apply(void 0, [props].concat(_toConsumableArray(commonItemPropsArray)));
};
function extractPropsWithPrefix(props, prefix) {
  var result = {};
  for (var key in props) {
    if (key.startsWith(prefix)) {
      result[key] = props[key];
    }
  }
  return result;
}
function extractDataProps(props) {
  return extractPropsWithPrefix(props, 'data-');
}
function extractAriaProps(props) {
  return extractPropsWithPrefix(props, 'aria-');
}

export { extractAriaProps, extractCommonItemProps, extractDataProps, extractProps };
//# sourceMappingURL=layoutPropsExtractor.js.map
